<template>
  <el-card class="h-full" :body-style="{ height: '100%' }">
    <div>
      <el-input
        size="small"
        clearable
        placeholder="栏目名称"
        class="!w-200px mr-10px"
        v-model="search.name"
      />
      <el-select v-model="search.type" class="mr-10px" clearable placeholder="栏目类型">
        <el-option
          v-for="(option, index) in columnTypeList"
          :key="index"
          :label="option.displayName"
          :value="option.id"
        ></el-option>
      </el-select>
      <el-select v-model="search.category" class="mr-10px" clearable placeholder="栏目类别">
        <el-option
          v-for="(option, index) in columnCategoryList"
          :key="index"
          :label="option.displayName"
          :value="option.id"
        ></el-option>
      </el-select>
      <el-select v-model="search.source" class="mr-10px" clearable placeholder="栏目来源">
        <el-option
          v-for="(option, index) in columnSourceList"
          :key="index"
          :label="option.displayName"
          :value="option.id"
        ></el-option>
      </el-select>
      <el-button size="small" type="primary" @click="onSearch">搜索</el-button>
    </div>
    <el-table
      height="calc(100% - 58px)"
      class="mt-20px"
      border
      stripe
      :data="dispalyTabData"
      v-loading="tableLoading"
      row-key="id"
      :tree-props="{ children: 'child', hasChildren: 'isLeaf' }"
    >
      <el-table-column type="index" width="60" label="序号"></el-table-column>
      <el-table-column label="栏目名称" prop="name" show-overflow-tooltip></el-table-column>
      <el-table-column label="栏目层级" prop="parentId" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ getLevelByParentId(scope.row.parentId) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="栏目类型" prop="type" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ handleData(columnTypeList, scope.row.type) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="栏目类别" prop="category" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ handleData(columnCategoryList, scope.row.category) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="栏目来源" prop="source" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ handleData(columnSourceList, scope.row.source) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="今日访问次数" prop="dayNumberViews" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="历史访问次数" prop="numberViews" show-overflow-tooltip>
      </el-table-column>
    </el-table>
    <!-- <el-pagination
      class="text-right mt-20px"
      background
      @size-change="findList"
      @current-change="findList"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :total="page.pageTotal"
      layout="sizes, total, prev, pager, next, jumper"
      :pager-count="5"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
    >
    </el-pagination> -->
  </el-card>
</template>

<script>
import { ColumApi } from '@wiz-api/workbench'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import dayjs from 'dayjs'

const columApi = new ColumApi()
const dataCategoryApi = new DataCategoryApi()

export default {
  data() {
    return {
      search: {
        name: '',
        type: '',
        category: '',
        source: '',
      },
      tableData: [],
      dispalyTabData: [],
      columnTypeList: [
        {
          id: 1,
          displayName: '文字',
        },
        {
          id: 2,
          displayName: '图文',
        },
        {
          id: 3,
          displayName: '视频',
        },
      ],
      columnCategoryList: [],
      columnSourceList: [
        {
          id: 1,
          displayName: '门户栏目',
        },
        {
          id: 2,
          displayName: '外网栏目',
        },
      ],
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      tableLoading: false,
      selectCategory: 'ColumnCategory',
      searchDataList: [],
    }
  },
  methods: {
    async findList() {
      this.tableLoading = true
      this.searchDataList = []
      this.tableData = []
      this.dispalyTabData = []
      const [err, res] = await columApi.tree(0, { isVisit: true })
      this.tableLoading = false
      if (!err && res) {
        this.tableData = res
        this.dispalyTabData = this.tableData
        this.tableData.forEach((element) => {
          this.getSearchDataList(element)
        })
      }
    },
    // 递归获取所有树的节点
    getSearchDataList(item) {
      if (item != null) {
        this.searchDataList.push(item)
        item?.child?.forEach((element) => {
          this.getSearchDataList(element)
        })
      }
    },
    async getDataCategory() {
      const [err, res] = await dataCategoryApi.getByCode({
        code: this.selectCategory,
        includeDetails: true,
      })
      if (!err) {
        this.columnCategoryList = res.dataItems
      }
    },
    handleData(list, type) {
      let displayName = ''
      list.forEach((element) => {
        if (element.id === type) {
          displayName = element.displayName
        }
      })
      return displayName
    },
    getLevelByParentId(parentId) {
      let level = 0
      if (parentId != null) {
        level = level + 1
        this.searchDataList.forEach((element) => {
          if (parentId === element.id) {
            parentId = element.parentId
          }
        })
      }
      switch (level) {
        case 0:
          return '一级'
        case 1:
          return '二级'
        case 2:
          return '三级'
        case 3:
          return '四级'
        case 4:
          return '五级'
        case 5:
          return '六级'
        default:
          return ''
      }
    },
    onSearch() {
      const tempData = []
      this.searchDataList.forEach((element) => {
        let flag = true
        // 过滤名字
        if (this.search.name !== '' && !element.name.includes(this.search.name)) {
          flag = false
        }
        // 过滤类型
        if (this.search.type !== '' && element.type !== this.search.type) {
          flag = false
        }
        // 过滤类别
        if (this.search.category !== '' && element.category !== this.search.category) {
          flag = false
        }
        // 过滤来源
        if (this.search.source !== '' && element.source !== this.search.source) {
          flag = false
        }
        if (flag) {
          const item = _.cloneDeep(element)
          item.child = null
          item.parentId = null
          tempData.push(item)
        }
      })
      if (
        this.search.name === '' &&
        this.search.type === '' &&
        this.search.category === '' &&
        this.search.source === ''
      ) {
        // this.dispalyTabData = this.tableData
        this.findList()
      } else {
        this.dispalyTabData = tempData
      }
    },
  },
  created() {
    this.findList()
    this.getDataCategory()
  },
}
</script>

<style lang="scss" scoped></style>
